export default "__VITE_ASSET__BzWcLHLN__"